import React, { createContext, useContext, useState, useEffect } from 'react'

const CartContext = createContext()

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([])
  const [isCartOpen, setIsCartOpen] = useState(false)

  useEffect(() => {
    const storedCart = localStorage.getItem('cartItems')

    if (storedCart) {
      setCartItems(JSON.parse(storedCart))
    }
  }, [])

  useEffect(() => {
    if (cartItems.length > 0) {
      localStorage.setItem('cartItems', JSON.stringify(cartItems))
    } else {
      localStorage.removeItem('cartItems')
    }
  }, [cartItems])

  useEffect(() => {
    const handleStorageChange = () => {
      const storedCart = localStorage.getItem('cartItems')

      if (storedCart) {
        setCartItems(JSON.parse(storedCart))
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  const addToCart = (product) => {
    setCartItems((prevCartItems) => {
      const existingProductIndex = prevCartItems.findIndex(
        (item) => item.id === product.id
      )

      let updatedCartItems

      if (existingProductIndex !== -1) {
        updatedCartItems = [...prevCartItems]

        updatedCartItems[existingProductIndex].quantity += product.quantity || 1
      } else {
        updatedCartItems = [
          ...prevCartItems,
          {
            ...product,
            quantity: product.quantity || 1
          }
        ]
      }

      localStorage.setItem('cartItems', JSON.stringify(updatedCartItems))

      return updatedCartItems
    })

    // Abrir automáticamente el carrito
    setIsCartOpen(true)
  }

  const removeFromCart = (id) => {
    setCartItems((prevCartItems) => {
      return prevCartItems.filter((item) => item.id !== id)
    })
  }

  const getTotalItems = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0)
  }

  const syncCart = (newCart) => {
    setCartItems(newCart)

    localStorage.setItem('cartItems', JSON.stringify(newCart))
  }

  const closeCart = () => {
    setIsCartOpen(false)
  }

  const toggleCart = () => {
    setIsCartOpen((prev) => !prev)
  }

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        getTotalItems,
        setCartItems: syncCart,
        isCartOpen,
        closeCart,
        toggleCart
      }}
    >
      {children}
    </CartContext.Provider>
  )
}

export const useCart = () => useContext(CartContext)
